import React, { useCallback } from 'react';
import { FC132 } from '../../../services/c205Api';

interface BoardDetailTableProps {
  boardDetails: Partial<FC132>[];
  isEditing: boolean;
  setBoardDetails: React.Dispatch<React.SetStateAction<Partial<FC132>[]>>;
}

const BoardDetailTable: React.FC<BoardDetailTableProps> = ({
  boardDetails, isEditing, setBoardDetails,
}) => {
  const handleCellChange = useCallback((rowIdx: number, key: keyof FC132, value: string) => {
    setBoardDetails(prev => {
      const next = [...prev];
      if (next[rowIdx]) {
        next[rowIdx] = { ...next[rowIdx], [key]: value };
      }
      return next;
    });
  }, [setBoardDetails]);

  const addBoardRow = useCallback(() => {
    const maxSeq = boardDetails.reduce((max, d) => Math.max(max, d.fc132_03 || 0), 0);
    setBoardDetails(prev => [...prev, {
      fc132_01: '',
      fc132_02: 1,
      fc132_03: maxSeq + 1,
      fc132_11: '',
      fc132_90: 0,
    }]);
  }, [boardDetails, setBoardDetails]);

  const deleteBoardRow = useCallback((idx: number) => {
    setBoardDetails(prev => {
      const next = prev.filter((_, i) => i !== idx);
      return next.map((d, i) => ({ ...d, fc132_03: i + 1 }));
    });
  }, [setBoardDetails]);

  return (
    <div className="c205-board-section">
      {isEditing && (
        <div className="detail-actions">
          <button className="btn btn-sm" onClick={addBoardRow}>板號新增</button>
        </div>
      )}

      <div className="detail-table-wrapper">
        <table className="detail-table">
          <thead>
            <tr>
              <th style={{ width: 80 }}>明細項次</th>
              <th style={{ width: 80 }}>板號項次</th>
              <th style={{ width: 200 }}>板號</th>
              {isEditing && <th style={{ width: 60 }}>操作</th>}
            </tr>
          </thead>
          <tbody>
            {boardDetails.map((d, i) => (
              <tr key={i}>
                <td style={{ textAlign: 'center' }}>{d.fc132_02 ?? '--'}</td>
                <td style={{ textAlign: 'center' }}>{d.fc132_03 ?? i + 1}</td>
                <td>
                  {isEditing ? (
                    <input type="text" style={{ width: '100%' }}
                      value={d.fc132_11 || ''}
                      onChange={e => handleCellChange(i, 'fc132_11', e.target.value)}
                    />
                  ) : (d.fc132_11 || '')}
                </td>
                {isEditing && (
                  <td style={{ textAlign: 'center' }}>
                    <button className="btn btn-sm btn-danger" onClick={() => deleteBoardRow(i)}>刪除</button>
                  </td>
                )}
              </tr>
            ))}
            {boardDetails.length === 0 && (
              <tr>
                <td colSpan={isEditing ? 4 : 3} style={{ textAlign: 'center', color: '#999' }}>
                  無板號資料
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default React.memo(BoardDetailTable);
